import React from "react";
import { Box, Typography } from "@mui/material";

type Props = {
  /** Left side: a page title (string) or tabs. */
  left: React.ReactNode;
  /** Right side: filters and the page's actions (Add last). */
  right?: React.ReactNode;
};

/** Page heading row: title/tabs on the left, filters + actions on the right, divider under it. */
const PageTopBar: React.FC<Props> = ({ left, right }) => (
  <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ borderBottom: 1, borderColor: "divider", pb: 1, mb: 2 }}>
    {typeof left === "string" ? (
      <Typography variant="h6" fontWeight={600}>
        {left}
      </Typography>
    ) : (
      left
    )}
    <Box flexGrow={1} />
    {right}
  </Box>
);

export default PageTopBar;
